import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import Link from "plos/src/components/links/Link";
import PageTitle from "plos/src/components/PageTitle";
import Subheading from "plos/src/components/Subheading";
import { SurfaceContainer } from "plos/src/components/SurfaceContainer";
import { WebViewContext } from "plos/src/contexts/WebViewContext";
import { contentMain, pagePadding, rightSidebarLayout } from "plos/src/layouts";
import { footnote } from "plos/src/styles/utils.css";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useTrackingContext } from "../../contexts/TrackingContext";
import { HelmetHead } from "../HelmetHead";
import { prizesWrapper } from "./prizes.css";
import PrizesNav from "./PrizesNav";

const Prizes = () => {
  const { t } = useTranslation("prizes");
  const { firePageViewEvent } = useTrackingContext();

  const currentEvent = useSelector(getCurrentEvent);
  const { isWebView } = useContext(WebViewContext);

  useEffect(() => {
    firePageViewEvent("fantasy prizes");
  }, []);

  return (
    <>
      <HelmetHead
        title={t(
          "metadata.title",
          "Fantasy Football Game Prizes | Fantasy Premier League",
        )}
        description={t(
          "metadata.description",
          "To find out about Fantasy Premier League prizes, including overall, monthly and weekly prizes, visit the official website of the Premier League.",
        )}
      />
      <div className={rightSidebarLayout}>
        <div className={contentMain}>
          {currentEvent &&
            (currentEvent.id > 1 || currentEvent.finished) &&
            !isWebView && <PrizesNav selected="prizes" />}
          <div className={prizesWrapper}>
            <SurfaceContainer>
              <div className={contentMain}>
                <PageTitle title={t("pageTitle", "Prizes")} />
                <Subheading>
                  {t("overallSubheading", "Overall Prizes")}
                </Subheading>
                <h3>
                  {t(
                    "overallFirstPrizeTitle",
                    "1st Prize - 2026/27 Fantasy Premier League Champion",
                  )}
                </h3>
                <ul>
                  <li>
                    {t(
                      "prizeOne",
                      "7-night break in the UK inclusive of two VIP hospitality at two 2027/28 Premier League matches",
                    )}
                  </li>
                  <li>
                    {t(
                      "prizeTwo",
                      "A selection of experiences at popular UK tourist attractions",
                    )}
                  </li>
                  <li>
                    {t(
                      "prizeThree",
                      "Includes travel and 7 nights’ accommodation",
                    )}
                  </li>
                  <li>{t("prizeFour", "Microsoft Surface Laptop")}</li>
                  <li>
                    {t(
                      "prizeFive",
                      "4 Hobby Boxes of Topps Premier League (Chrome, Merlin, Pristine and Finest)",
                    )}
                  </li>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
                <h3>{t("overallRunnerUpPrizeTitle", "Runner-up")}</h3>
                <ul>
                  <li>
                    {t(
                      "prizeThirteen",
                      "Two hospitality tickets at one 2027/28 Premier League match",
                    )}
                  </li>
                  <li>
                    {t(
                      "prizeTwelve",
                      "Includes travel and 3 nights’ accommodation",
                    )}
                  </li>
                  <li>{t("prizeFour", "Microsoft Surface Laptop")}</li>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
                <h3>{t("overallThirdPrizeTitle", "3rd place")}</h3>
                <ul>
                  <li>{t("prizeFour", "Microsoft Surface Laptop")}</li>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
                <h3>{t("overallRemainingPrizeTitle", "4th-10th place")}</h3>
                <ul>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>

                <h3>{t("cupWinnerTitle", "2026/27 FPL Cup Winner")}</h3>
                <ul>
                  <li>
                    {t(
                      "prizeThirteen",
                      "Two hospitality tickets at one 2027/28 Premier League match",
                    )}
                  </li>
                  <li>
                    {t(
                      "prizeTwelve",
                      "Includes travel and 3 nights’ accommodation",
                    )}
                  </li>
                  <li>{t("prizeFour", "Microsoft Surface Laptop")}</li>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
                <h3>{t("cupRunnerUpTitle", "2026/27 FPL Cup Runner-up")}</h3>
                <ul>
                  <li>{t("prizeFour", "Microsoft Surface Laptop")}</li>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
              </div>
            </SurfaceContainer>

            <SurfaceContainer>
              <div className={contentMain}>
                <Subheading>
                  {t("secondChanceTitle", "Second Chance League")}
                </Subheading>
                <h3>{t("firstPrize", "1st Prize")}</h3>
                <ul>
                  <li>
                    {t(
                      "prizeThirteen",
                      "Two hospitality tickets at one 2027/28 Premier League match",
                    )}
                  </li>
                  <li>
                    {t(
                      "prizeTwelve",
                      "Includes travel and 3 nights’ accommodation",
                    )}
                  </li>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
                <Subheading>{t("onePercentLeague", "1% League")}</Subheading>
                <h3>{t("firstPrize", "1st Prize")}</h3>
                <ul>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
                <Subheading>{t("tenPercentLeague", "10% League")}</Subheading>
                <h3>{t("firstPrize", "1st Prize")}</h3>
                <ul>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
                <Subheading>{t("rookieLeague", "Rookie League")}</Subheading>
                <h3>{t("firstPrize", "1st Prize")}</h3>
                <ul>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
              </div>
            </SurfaceContainer>

            <SurfaceContainer>
              <div className={contentMain}>
                <Subheading>{t("monthly", "Monthly")}</Subheading>
                <h3>{t("managerMonth", "Manager of the Month")}</h3>
                <ul>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
              </div>
            </SurfaceContainer>
            <SurfaceContainer>
              <div className={contentMain}>
                <Subheading>{t("weekly", "Weekly")}</Subheading>
                <h3>
                  {t("managerWeek", "Manager of the Week")}
                  <sup>
                    <Link to="#ism-prizes-footnote">*</Link>
                  </sup>
                </h3>
                <ul>
                  <li>{t("prizeSix", "Puma Training Top or Hoodie")}</li>
                  <li>{t("prizeSeven", "Puma Football")}</li>
                  <li>
                    {t(
                      "prizeEight",
                      "Official Premier League Club Replica Shirt",
                    )}
                  </li>
                  <li>{t("prizeNine", "EA SPORTS FC™ game")}</li>
                  <li>{t("prizeTen", "Official FPL Certificate")}</li>
                  <li>
                    {t(
                      "prizeEleven",
                      "FPL bundle consisting of a T-shirt, mug, thermal bottle, stress ball, pen, pad and key ring",
                    )}
                  </li>
                </ul>
              </div>
            </SurfaceContainer>
            <div className={pagePadding}>
              <p className={footnote} id="ism-prizes-footnote">
                <sup>*</sup>{" "}
                {t(
                  "footnote",
                  "To be eligible to win a Manager of the week prize, you must have joined the game before the start of the 2026/27 season or a minimum of two clear Gameweeks before the one in which you are top of the weekly leaderboard. Players who have played a chip (including Bench Boost, Free Hit, Triple Captain or Wildcard) will not be eligible to win a Manager of the Week prize for the Gameweek that such a chip has been used.",
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Prizes;
